// Teklif listesinin "yalnız benim kararımı bekleyenler" derin bağlantı kipi.
//
// NEDEN AYRI (ve saf) BİR MODÜL: bu sabiti Onaylarım panelinin kategori kaydı
// (approvals/config/categories.js) da okur. Sayfanın KENDİSİNDEN (AtsOffersPage)
// içe aktarmak, menüyü çizen hafif bir modüle koca bir sayfa bileşenini —
// diyalogları, DataTable'ı, axios çağrılarını — bağlardı. Kadro talebindeki
// `requisitionActions.js` aynı gerekçeyle ayrı duruyor.
//
// Dize kadro talebiyle AYNI: kullanıcı iki kartta da adres çubuğunda aynı şeyi
// görür ve iki sayfa aynı deyimi konuşur.
export const PENDING_APPROVAL_MODE = 'pendingApproval';
